import { useAuth } from "../../context/AuthContext";
import { Modal } from "../../components/ui/modal";
import { Badge } from "../../components/ui/badge";
import { formatDuration, formatTimestamp } from "../../lib/time";
import { SENTIMENT_META, STATUS_META, type CallRecord } from "./types";

export function PcaModal({ call, onClose }: { call: CallRecord; onClose: () => void }) {
  const { user } = useAuth() as any;
  const st = STATUS_META[call.status];
  const se = SENTIMENT_META[call.sentiment];

  return (
    <Modal
      title="Post-Call Analysis"
      subtitle={<span className="font-mono text-xs">{call.executionId}</span>}
      onClose={onClose}
      width="max-w-xl"
    >
      {/* Meta row */}
      <div className="mb-4 flex flex-wrap items-center gap-2 text-xs text-ink-2">
        <Badge tone={st.tone}>{st.label}</Badge>
        <Badge tone={se.tone}>{se.label}</Badge>
        <span className="font-mono">{formatDuration(call.durationSec)}</span>
        <span>·</span>
        <span>{formatTimestamp(call.createdAt, user?.timezone)}</span>
        <span>·</span>
        <span className="capitalize">Hung by {call.hungBy}</span>
      </div>

      {/* Outcomes grid */}
      <p className="mb-2 font-mono text-[10px] font-semibold uppercase tracking-wider text-ink-3">
        Extracted Outcomes
      </p>
      <div className="grid grid-cols-2 gap-3">
        {call.outcomes.map((o) => (
          <div key={o.field} className="rounded-lg bg-soft p-3">
            <p className="font-mono text-[10px] uppercase tracking-wider text-ink-3">{o.field}</p>
            <p className="mt-1 text-sm font-bold text-ink">{o.value}</p>
          </div>
        ))}
        {call.outcomes.length === 0 && (
          <p className="col-span-2 text-sm text-ink-3">No outcomes extracted for this call.</p>
        )}
      </div>

      {/* AI insights */}
      <div className="mt-4 rounded-lg bg-soft p-4">
        <p className="mb-2 font-mono text-[10px] font-semibold uppercase tracking-wider text-ink-3">AI Insights</p>
        <ul className="space-y-1.5">
          {call.aiSummary.map((s, i) => (
            <li key={i} className="flex items-start gap-2 text-sm text-ink-2">
              <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-brand" /> {s}
            </li>
          ))}
        </ul>
      </div>
    </Modal>
  );
}
